/* Handles negative mod */
export const mod = (n, m) => ((n % m) + m) % m;
//# sourceMappingURL=mod.js.map